<template>
  <b-form-select
    v-model="item"
    :options="Options"
    @change="onChange(Options, $event)"
  ></b-form-select>
</template>

<script>
import httpHelper from "../helpers/httpHelper";
import sessionHelper from "../helpers/sessionHelper";

export default {
  name: "MDDropdown",
  props: ["group", "value", "parent"],
  data: function () {
    return {
      data: [],
      Options: [],
      item: null,
    };
  },
  watch: {
    value: function (newVal, oldVal) {
      this.item = this.value;
    },
    parent: function (newVal, oldVal) {
      this.getOptions();
    },
    group(){
      this.getData();
    }
  },
  mounted() {
    this.getData();
  },
  methods: {
    onChange(options, event) {
      if (this.group == 120) {
        let opt = options.filter((v) => v.value == event);
        this.$emit("input", opt);
      } else {
        this.$emit("input", event);
      }
    },
    getOptions() {
      if (this.parent != null && this.parent != 0) {
        this.Options = [];
        this.data.forEach((element) => {
          if (element.parent == this.parent) {
            this.Options.push(element);
          }
        });
      } else {
        this.Options = this.data;
      }
      this.Options.push({ parent: null, value: null, text: "انتخاب نشده" });
      this.Options.reverse();
    },
    getData() {
      httpHelper
        .getData("metadata?metadata_group_id=" + this.group)
        .then((res) => {
          this.data = res.result.map((element) => {
            return {
              parent: element.parent_id,
              value: element.id,
              text: element.title,
              description: element.description,
            };
          });
          if (this.value) this.item = this.value;
          this.getOptions();
        });
    },
  },
};
</script>